(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    class BackToTop {
    constructor() {
      this.button = document.querySelector('[data-back-to-top]');
      if (!this.button) return;

      this.threshold = 400;
      this.bindEvents();
    }

    bindEvents() {
      let ticking = false;

      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            this.toggleVisibility();
            ticking = false;
          });
          ticking = true;
        }
      });

      this.button.addEventListener('click', () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }

    toggleVisibility() {
      if (window.scrollY > this.threshold) {
        this.button.removeAttribute('hidden');
      } else {
        this.button.setAttribute('hidden', '');
      }
    }
  }

  new BackToTop();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer-item"] && !Shopify.designMode) return;
  try {
    class CartDrawerItem {
    constructor() {
      this.bindEvents();
    }

    bindEvents() {
      document.addEventListener('click', async (e) => {
        const item = e.target.closest('[data-cart-item]');
        if (!item) return;

        const lineKey = item.dataset.lineKey;

        if (e.target.closest('[data-remove-item]')) {
          await this.updateQuantity(lineKey, 0);
        } else if (e.target.closest('[data-decrease-quantity]')) {
          const input = item.querySelector('[data-quantity-input]');
          const newQty = Math.max(0, parseInt(input.value, 10) - 1);
          await this.updateQuantity(lineKey, newQty);
        } else if (e.target.closest('[data-increase-quantity]')) {
          const input = item.querySelector('[data-quantity-input]');
          const newQty = parseInt(input.value, 10) + 1;
          await this.updateQuantity(lineKey, newQty);
        }
      });

      document.addEventListener('change', async (e) => {
        if (e.target.matches('[data-quantity-input]')) {
          const item = e.target.closest('[data-cart-item]');
          if (item) {
            await this.updateQuantity(item.dataset.lineKey, parseInt(e.target.value, 10));
          }
        }
      });
    }

    async updateQuantity(lineKey, quantity) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity })
      });

      if (response.ok) {
        const cart = await response.json();
        this.updateCartUI(cart);
      }
    }

    updateCartUI(cart) {
      // Update cart count in header
      const countElements = document.querySelectorAll('[data-cart-count]');
      for (const el of countElements) {
        el.textContent = `(${cart.item_count})`;
      }

      // Update subtotal
      const subtotalEl = document.querySelector('[data-cart-subtotal]');
      if (subtotalEl) {
        subtotalEl.textContent = Shopify.formatMoney ? Shopify.formatMoney(cart.total_price) : `$${(cart.total_price / 100).toFixed(2)}`;
      }

      // Refresh drawer content
      this.refreshDrawer();
    }

    async refreshDrawer() {
      const drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer) return;

      const response = await fetch(`${window.location.pathname}?section_id=cart-drawer-content`);
      const html = await response.text();

      // Simple refresh - reload the page section
      window.location.reload();
    }
  }

  new CartDrawerItem();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDrawer {
    constructor() {
      this.drawer = document.querySelector('[data-cart-drawer]');
      if (!this.drawer) return;

      this.overlay = this.drawer.querySelector('.cart-drawer__overlay');
      this.content = this.drawer.querySelector('[data-cart-drawer-content]');
      this.closeButtons = this.drawer.querySelectorAll('[data-cart-drawer-close]');
      this.giftWrapCheckbox = this.drawer.querySelector('[data-gift-wrap-checkbox]');
      this.giftMessageContainer = this.drawer.querySelector('[data-gift-message-container]');

      this.bindEvents();
      this.setupCartTriggers();
    }

    bindEvents() {
      for (const btn of this.closeButtons) {
        btn.addEventListener('click', () => this.close());
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.getAttribute('aria-hidden') === 'false') {
          this.close();
        }
      });

      if (this.giftWrapCheckbox) {
        this.giftWrapCheckbox.addEventListener('change', () => {
          if (this.giftMessageContainer) {
            this.giftMessageContainer.style.display = this.giftWrapCheckbox.checked ? 'block' : 'none';
          }
          this.updateCartAttributes();
        });
      }
    }

    setupCartTriggers() {
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-cart-drawer-trigger]');
        if (trigger) {
          e.preventDefault();
          this.open();
        }
      });
    }

    open() {
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    async updateCartAttributes() {
      const formData = new FormData();
      formData.append('attributes[gift_wrapping]', this.giftWrapCheckbox?.checked ? 'yes' : '');

      const giftMessage = this.drawer.querySelector('[data-gift-message]');
      if (giftMessage) {
        formData.append('attributes[gift_message]', giftMessage.value);
      }

      await fetch('/cart/update.js', {
        method: 'POST',
        body: formData
      });
    }

    async refreshCart() {
      const response = await fetch('/?section_id=cart-drawer-content');
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.querySelector('[data-cart-drawer-content]');
      if (newContent && this.content) {
        this.content.innerHTML = newContent.innerHTML;
      }
    }
  }

  new CartDrawer();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    class CollectionFilters {
    constructor() {
      this.container = document.querySelector('[data-collection-filters]');
      if (!this.container) return;

      this.form = this.container.querySelector('[data-filters-form]');
      this.drawer = this.container.querySelector('[data-filters-container]');
      this.toggle = this.container.querySelector('[data-filters-toggle]');
      this.closeBtn = this.container.querySelector('[data-filters-close]');
      this.overlay = this.container.querySelector('[data-filters-overlay]');
      this.sortSelect = this.container.querySelector('[data-sort-select]');
      this.filterInputs = this.container.querySelectorAll('[data-filter-input]');

      this.bindEvents();
    }

    bindEvents() {
      // Toggle drawer
      this.toggle?.addEventListener('click', () => this.openDrawer());
      this.closeBtn?.addEventListener('click', () => this.closeDrawer());
      this.overlay?.addEventListener('click', () => this.closeDrawer());

      // Sort change
      this.sortSelect?.addEventListener('change', () => this.submitFilters());

      // Filter change (with debounce)
      let debounceTimer;
      for (const input of this.filterInputs) {
        input.addEventListener('change', () => {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => this.submitFilters(), 500);
        });
      }

      // Escape to close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer?.getAttribute('aria-hidden') === 'false') {
          this.closeDrawer();
        }
      });
    }

    openDrawer() {
      this.drawer?.setAttribute('aria-hidden', 'false');
      this.toggle?.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    closeDrawer() {
      this.drawer?.setAttribute('aria-hidden', 'true');
      this.toggle?.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    submitFilters() {
      if (!this.form) return;

      const formData = new FormData(this.form);
      const params = new URLSearchParams();

      for (const [key, value] of formData) {
        if (value) params.append(key, value);
      }

      const url = `${window.location.pathname}?${params.toString()}`;
      window.location.href = url;
    }
  }

  new CollectionFilters();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["color-swatches"] && !Shopify.designMode) return;
  try {
    class ColorSwatches {
    constructor() {
      this.bindEvents();
    }

    bindEvents() {
      document.addEventListener('change', (e) => {
        if (!e.target.matches('.color-swatches__input')) return;

        const container = e.target.closest('[data-color-swatches]');
        if (!container) return;

        // Update selected state
        const options = container.querySelectorAll('[data-swatch-option]');
        for (const opt of options) {
          opt.classList.remove('color-swatches__option--selected');
        }
        e.target.closest('[data-swatch-option]').classList.add('color-swatches__option--selected');

        // Update selected value label
        const selectedLabel = container.querySelector('[data-selected-value]');
        if (selectedLabel) {
          selectedLabel.textContent = e.target.value;
        }

        // Dispatch custom event for variant updates
        const event = new CustomEvent('swatch:change', {
          bubbles: true,
          detail: {
            optionIndex: parseInt(e.target.dataset.optionIndex, 10),
            value: e.target.value
          }
        });
        container.dispatchEvent(event);
      });
    }
  }

  new ColorSwatches();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-zoom"] && !Shopify.designMode) return;
  try {
    class ImageZoom {
    constructor() {
      this.initHoverZoom();
      this.initClickZoom();
      this.initLightbox();
    }

    initHoverZoom() {
      const hoverZooms = document.querySelectorAll('[data-image-zoom][data-zoom-type="hover"]');

      for (const container of hoverZooms) {
        const image = container.querySelector('[data-zoom-image]');
        const lens = container.querySelector('[data-zoom-lens]');
        const result = container.querySelector('[data-zoom-result]');

        if (!image || !lens || !result) continue;

        const highResSrc = image.dataset.highRes;
        let cx, cy;

        container.addEventListener('mouseenter', () => {
          result.style.backgroundImage = `url(${highResSrc})`;
          cx = result.offsetWidth / lens.offsetWidth;
          cy = result.offsetHeight / lens.offsetHeight;
          result.style.backgroundSize = `${image.width * cx}px ${image.height * cy}px`;
        });

        container.addEventListener('mousemove', (e) => {
          const rect = image.getBoundingClientRect();
          let x = e.clientX - rect.left - lens.offsetWidth / 2;
          let y = e.clientY - rect.top - lens.offsetHeight / 2;

          x = Math.max(0, Math.min(x, image.width - lens.offsetWidth));
          y = Math.max(0, Math.min(y, image.height - lens.offsetHeight));

          lens.style.left = `${x}px`;
          lens.style.top = `${y}px`;
          result.style.backgroundPosition = `-${x * cx}px -${y * cy}px`;
        });
      }
    }

    initClickZoom() {
      const clickZooms = document.querySelectorAll('[data-image-zoom][data-zoom-type="click"]');

      for (const container of clickZooms) {
        const trigger = container.querySelector('[data-zoom-trigger]');
        const image = container.querySelector('[data-zoom-image]');

        if (!trigger || !image) continue;

        let zoomed = false;

        trigger.addEventListener('click', () => {
          zoomed = !zoomed;
          if (zoomed) {
            image.src = image.dataset.highRes;
            container.classList.add('image-zoom--zoomed');
          } else {
            image.src = image.src.replace(/width=\d+/, 'width=800');
            container.classList.remove('image-zoom--zoomed');
          }
        });
      }
    }

    initLightbox() {
      const lightboxZooms = document.querySelectorAll('[data-image-zoom][data-zoom-type="lightbox"]');

      for (const container of lightboxZooms) {
        const trigger = container.querySelector('[data-zoom-trigger]');
        const image = container.querySelector('[data-zoom-image]');
        const lightbox = container.querySelector('[data-zoom-lightbox]');
        const lightboxImage = container.querySelector('[data-zoom-lightbox-image]');
        const closeBtn = container.querySelector('[data-zoom-lightbox-close]');

        if (!trigger || !image || !lightbox || !lightboxImage) continue;

        trigger.addEventListener('click', () => {
          lightboxImage.src = image.dataset.highRes;
          lightboxImage.alt = image.alt;
          lightbox.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        });

        const closeLightbox = () => {
          lightbox.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        };

        closeBtn?.addEventListener('click', closeLightbox);
        lightbox.addEventListener('click', (e) => {
          if (e.target === lightbox) closeLightbox();
        });

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && lightbox.getAttribute('aria-hidden') === 'false') {
            closeLightbox();
          }
        });
      }
    }
  }

  new ImageZoom();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["infinite-scroll"] && !Shopify.designMode) return;
  try {
    class InfiniteScroll {
    constructor() {
      this.container = document.querySelector('[data-infinite-scroll]');
      if (!this.container) return;

      this.mode = this.container.dataset.mode;
      this.threshold = parseInt(this.container.dataset.threshold, 10);
      this.currentPage = parseInt(this.container.dataset.currentPage, 10);
      this.totalPages = parseInt(this.container.dataset.totalPages, 10);
      this.nextUrl = this.container.dataset.nextUrl;

      this.loader = this.container.querySelector('[data-loader]');
      this.endMessage = this.container.querySelector('[data-end-message]');
      this.sentinel = this.container.querySelector('[data-sentinel]');
      this.loadMoreBtn = this.container.querySelector('[data-load-more]');

      this.isLoading = false;
      this.hasReachedEnd = this.currentPage >= this.totalPages;

      this.init();
    }

    init() {
      if (this.hasReachedEnd) {
        this.showEndMessage();
        return;
      }

      if (this.mode === 'auto') {
        this.initIntersectionObserver();
      } else if (this.mode === 'button' && this.loadMoreBtn) {
        this.loadMoreBtn.addEventListener('click', () => this.loadMore());
      }
    }

    initIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: `${this.threshold}px`,
        threshold: 0
      };

      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && !this.isLoading && !this.hasReachedEnd) {
            this.loadMore();
          }
        }
      }, options);

      this.observer.observe(this.sentinel);
    }

    async loadMore() {
      if (this.isLoading || this.hasReachedEnd || !this.nextUrl) return;

      this.isLoading = true;
      this.showLoader();

      try {
        const response = await fetch(this.nextUrl);
        const html = await response.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Find the product grid and append new items
        const newProducts = doc.querySelectorAll('[data-product-card]');
        const currentGrid = document.querySelector('[data-product-grid]');

        if (currentGrid && newProducts.length > 0) {
          for (const product of newProducts) {
            // Add animation class for new items
            product.classList.add('animate-fade-in-up');
            currentGrid.appendChild(product);
          }
        }

        // Update pagination info
        this.currentPage++;
        const newPagination = doc.querySelector('[data-infinite-scroll]');

        if (newPagination) {
          this.nextUrl = newPagination.dataset.nextUrl;
        } else {
          this.nextUrl = null;
        }

        // Check if we've reached the end
        if (this.currentPage >= this.totalPages || !this.nextUrl) {
          this.hasReachedEnd = true;
          this.showEndMessage();

          if (this.observer) {
            this.observer.disconnect();
          }

          if (this.loadMoreBtn) {
            this.loadMoreBtn.disabled = true;
          }
        }

        // Update URL without reload
        const newUrl = new URL(window.location);
        newUrl.searchParams.set('page', this.currentPage);
        window.history.replaceState({}, '', newUrl);

      } catch (error) {
        console.error('Infinite scroll error:', error);
      } finally {
        this.isLoading = false;
        this.hideLoader();
      }
    }

    showLoader() {
      if (this.loader) {
        this.loader.setAttribute('aria-hidden', 'false');
      }
      if (this.loadMoreBtn) {
        this.loadMoreBtn.classList.add('is-loading');
      }
    }

    hideLoader() {
      if (this.loader) {
        this.loader.setAttribute('aria-hidden', 'true');
      }
      if (this.loadMoreBtn) {
        this.loadMoreBtn.classList.remove('is-loading');
      }
    }

    showEndMessage() {
      if (this.endMessage) {
        this.endMessage.setAttribute('aria-hidden', 'false');
      }
      if (this.loader) {
        this.loader.setAttribute('aria-hidden', 'true');
      }
    }
  }

  new InfiniteScroll();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-selector"] && !Shopify.designMode) return;
  try {
    class LocalizationSelector {
    constructor() {
      this.toggles = document.querySelectorAll('[data-localization-toggle]');
      this.lists = document.querySelectorAll('[data-localization-list]');

      if (this.toggles.length === 0) return;

      this.bindEvents();
    }

    bindEvents() {
      for (const toggle of this.toggles) {
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleList(toggle);
        });
      }

      document.addEventListener('click', (e) => {
        if (!e.target.closest('.localization-selector__item')) {
          this.closeAllLists();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeAllLists();
        }
      });
    }

    toggleList(toggle) {
      const type = toggle.dataset.localizationToggle;
      const list = document.querySelector(`[data-localization-list="${type}"]`);
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      this.closeAllLists();

      if (!isExpanded) {
        toggle.setAttribute('aria-expanded', 'true');
        list.hidden = false;
      }
    }

    closeAllLists() {
      for (const toggle of this.toggles) {
        toggle.setAttribute('aria-expanded', 'false');
      }
      for (const list of this.lists) {
        list.hidden = true;
      }
    }
  }

  new LocalizationSelector();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add"] && !Shopify.designMode) return;
  try {
    class QuickAdd {
    constructor() {
      this.bindEvents();
    }

    bindEvents() {
      // Quick add form submission (AJAX)
      document.addEventListener('submit', async (e) => {
        const form = e.target.closest('[data-quick-add-form]');
        if (!form) return;

        e.preventDefault();
        const btn = form.querySelector('button');
        btn.disabled = true;

        try {
          const formData = new FormData(form);
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            const item = await response.json();
            this.openCartDrawer();
            this.updateCartCount();
          }
        } catch (error) {
          console.error('Quick add error:', error);
        } finally {
          btn.disabled = false;
        }
      });

      // Quick add modal trigger for multi-variant products
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-quick-add-modal-trigger]');
        if (trigger) {
          e.preventDefault();
          const handle = trigger.dataset.productHandle;
          this.openQuickAddModal(handle);
        }
      });
    }

    openCartDrawer() {
      const drawer = document.querySelector('[data-cart-drawer]');
      if (drawer) {
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    }

    async updateCartCount() {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const countElements = document.querySelectorAll('[data-cart-count]');
      for (const el of countElements) {
        el.textContent = `(${cart.item_count})`;
      }
      const headerCounts = document.querySelectorAll('[data-cart-item-count]');
      for (const el of headerCounts) {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      }
    }

    async openQuickAddModal(handle) {
      // Trigger quick view modal with add to cart focus
      const event = new CustomEvent('quick-add:open', { detail: { handle } });
      document.dispatchEvent(event);
    }
  }

  new QuickAdd();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view"] && !Shopify.designMode) return;
  try {
    class QuickView {
    constructor() {
      this.modal = document.querySelector('[data-quick-view-modal]');
      if (!this.modal) return;

      this.content = this.modal.querySelector('[data-quick-view-content]');
      this.loading = this.modal.querySelector('[data-quick-view-loading]');
      this.closeButtons = this.modal.querySelectorAll('[data-quick-view-close]');

      this.bindEvents();
    }

    bindEvents() {
      for (const btn of this.closeButtons) {
        btn.addEventListener('click', () => this.close());
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal.getAttribute('aria-hidden') === 'false') {
          this.close();
        }
      });

      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-quick-view-trigger]');
        if (trigger) {
          e.preventDefault();
          const handle = trigger.dataset.productHandle;
          this.open(handle);
        }
      });

      document.addEventListener('quick-add:open', (e) => {
        if (e.detail?.handle) {
          this.open(e.detail.handle);
        }
      });
    }

    async open(handle) {
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this.showLoading();

      try {
        const response = await fetch(`/products/${handle}?section_id=quick-view-product`);
        const html = await response.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const productContent = doc.querySelector('[data-quick-view-product]');

        if (productContent) {
          this.content.innerHTML = productContent.innerHTML;
          this.initProductFeatures();
        }
      } catch (error) {
        console.error('Quick view error:', error);
        this.content.innerHTML = '<p style="padding: 2rem; text-align: center;">Error loading product</p>';
      }
    }

    close() {
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(() => {
        this.showLoading();
      }, 300);
    }

    showLoading() {
      this.content.innerHTML = this.loading.outerHTML;
    }

    initProductFeatures() {
      // Thumbnail clicks
      const thumbnails = this.content.querySelectorAll('[data-qv-thumbnail]');
      const mainImage = this.content.querySelector('[data-qv-main-image]');

      for (const thumb of thumbnails) {
        thumb.addEventListener('click', () => {
          if (mainImage) {
            mainImage.src = thumb.dataset.imageSrc;
          }
          for (const t of thumbnails) {
            t.classList.remove('quick-view__thumbnail--active');
          }
          thumb.classList.add('quick-view__thumbnail--active');
        });
      }

      // Quantity buttons
      const quantityMinus = this.content.querySelector('[data-qv-quantity-minus]');
      const quantityPlus = this.content.querySelector('[data-qv-quantity-plus]');
      const quantityInput = this.content.querySelector('[data-qv-quantity]');

      if (quantityMinus && quantityInput) {
        quantityMinus.addEventListener('click', () => {
          const current = parseInt(quantityInput.value, 10);
          if (current > 1) quantityInput.value = current - 1;
        });
      }

      if (quantityPlus && quantityInput) {
        quantityPlus.addEventListener('click', () => {
          const current = parseInt(quantityInput.value, 10);
          quantityInput.value = current + 1;
        });
      }

      // Variant selection
      const variantInputs = this.content.querySelectorAll('[data-qv-variant-input]');
      const variantIdInput = this.content.querySelector('[data-qv-variant-id]');
      const addBtn = this.content.querySelector('[data-qv-add-btn]');
      const priceDisplay = this.content.querySelector('[data-qv-price]');
      const variantData = this.content.querySelector('[data-qv-variants]');

      if (variantInputs.length > 0 && variantData) {
        const variants = JSON.parse(variantData.textContent);

        for (const input of variantInputs) {
          input.addEventListener('change', () => {
            const selectedOptions = [];
            const selectedInputs = this.content.querySelectorAll('[data-qv-variant-input]:checked');
            for (const sel of selectedInputs) {
              selectedOptions.push(sel.value);
            }

            const matchedVariant = variants.find(v =>
              v.options.every((opt, i) => opt === selectedOptions[i])
            );

            if (matchedVariant) {
              if (variantIdInput) variantIdInput.value = matchedVariant.id;
              if (addBtn) addBtn.disabled = !matchedVariant.available;
              if (priceDisplay) {
                priceDisplay.textContent = Shopify.formatMoney
                  ? Shopify.formatMoney(matchedVariant.price)
                  : `$${(matchedVariant.price / 100).toFixed(2)}`;
              }
            }
          });
        }
      }

      // Form submission
      const form = this.content.querySelector('[data-qv-form]');
      if (form) {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const formData = new FormData(form);

          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              body: formData
            });

            if (response.ok) {
              this.close();
              const drawer = document.querySelector('[data-cart-drawer]');
              if (drawer) {
                drawer.setAttribute('aria-hidden', 'false');
                document.body.style.overflow = 'hidden';
              }
              this.updateCartCount();
            }
          } catch (error) {
            console.error('Add to cart error:', error);
          }
        });
      }
    }

    async updateCartCount() {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const countElements = document.querySelectorAll('[data-cart-count]');
      for (const el of countElements) {
        el.textContent = `(${cart.item_count})`;
      }
    }
  }

  new QuickView();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-animations"] && !Shopify.designMode) return;
  try {
    class ScrollAnimations {
    constructor() {
      this.initElement = document.querySelector('[data-scroll-animations]');
      if (!this.initElement) return;

      this.threshold = parseFloat(this.initElement.dataset.threshold) || 0.1;
      this.delayIncrement = parseInt(this.initElement.dataset.delayIncrement, 10) || 100;
      this.respectMotion = this.initElement.dataset.respectMotion !== 'false';

      // Check for reduced motion preference
      if (this.respectMotion && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.showAllElements();
        return;
      }

      this.init();
    }

    init() {
      const options = {
        root: null,
        rootMargin: '0px 0px -50px 0px',
        threshold: this.threshold
      };

      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.animateElement(entry.target);
            this.observer.unobserve(entry.target);
          }
        }
      }, options);

      // Observe all elements with data-animate
      const animatedElements = document.querySelectorAll('[data-animate], [data-animate-stagger]');
      for (const el of animatedElements) {
        // Set custom delay and duration from data attributes
        if (el.dataset.animateDelay) {
          el.style.setProperty('--animate-delay', `${el.dataset.animateDelay}ms`);
        }
        if (el.dataset.animateDuration) {
          el.style.setProperty('--animate-duration', `${el.dataset.animateDuration}ms`);
        }

        this.observer.observe(el);
      }

      // Watch for dynamically added elements
      this.setupMutationObserver();
    }

    animateElement(el) {
      // Use requestAnimationFrame for smoother animations
      requestAnimationFrame(() => {
        el.classList.add('is-animated');
      });
    }

    showAllElements() {
      // For reduced motion, show all elements immediately
      const elements = document.querySelectorAll('[data-animate], [data-animate-stagger]');
      for (const el of elements) {
        el.classList.add('is-animated');
      }
    }

    setupMutationObserver() {
      const mutationObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Check if the added node has animation attributes
              if (node.dataset && (node.dataset.animate || node.dataset.animateStagger)) {
                this.observer.observe(node);
              }

              // Check children
              const animatedChildren = node.querySelectorAll?.('[data-animate], [data-animate-stagger]');
              if (animatedChildren) {
                for (const child of animatedChildren) {
                  this.observer.observe(child);
                }
              }
            }
          }
        }
      });

      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ScrollAnimations());
  } else {
    new ScrollAnimations();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-chart"] && !Shopify.designMode) return;
  try {
    class SizeChart {
    constructor() {
      this.bindEvents();
    }

    bindEvents() {
      // Open modal
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-size-chart-trigger]');
        if (trigger) {
          e.preventDefault();
          const container = trigger.closest('[data-size-chart]');
          const modal = container?.querySelector('[data-size-chart-modal]');
          if (modal) {
            modal.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
          }
        }
      });

      // Close modal
      document.addEventListener('click', (e) => {
        const closeBtn = e.target.closest('[data-size-chart-close]');
        if (closeBtn) {
          const modal = closeBtn.closest('[data-size-chart-modal]');
          if (modal) {
            modal.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
          }
        }
      });

      // Tab switching
      document.addEventListener('click', (e) => {
        const tab = e.target.closest('.size-chart__tab');
        if (!tab) return;

        const container = tab.closest('.size-chart__content');
        if (!container) return;

        const tabs = container.querySelectorAll('.size-chart__tab');
        const panels = container.querySelectorAll('.size-chart__panel');
        const targetPanel = tab.dataset.tab;

        for (const t of tabs) {
          t.classList.remove('size-chart__tab--active');
          t.setAttribute('aria-selected', 'false');
        }
        tab.classList.add('size-chart__tab--active');
        tab.setAttribute('aria-selected', 'true');

        for (const p of panels) {
          p.classList.remove('size-chart__panel--active');
          if (p.dataset.panel === targetPanel) {
            p.classList.add('size-chart__panel--active');
          }
        }
      });

      // Escape to close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const openModal = document.querySelector('[data-size-chart-modal][aria-hidden="false"]');
          if (openModal) {
            openModal.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
          }
        }
      });
    }
  }

  new SizeChart();
  } catch(e) { console.error(e); }
})();

})();
